import React from 'react';

import { Icon } from '@chakra-ui/react';

export const GCPModelArmorIcon = props => (
  <Icon viewBox="0 0 558 615" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-356 -50)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M447.061 541.765C453.975 545.005 457.434 546.622 462.23 547.459 465.971 548.112 471.36 548.112 475.101 547.459 479.897 546.622 483.356 545.005 490.271 541.765 554.23 511.843 738.16 414.066 738.16 279.128L738.16 164.722C738.16 140.539 738.16 128.448 733.752 118.054 729.864 108.871 723.539 100.679 715.33 94.1832 706.041 86.8299 693.43 82.5847 668.212 74.0934L487.591 13.276C480.589 10.9179 477.086 9.73879 473.484 9.27132 470.29 8.85683 467.041 8.85683 463.847 9.27132 460.245 9.73879 456.742 10.9179 449.74 13.276L269.119 74.0934C243.901 82.5847 231.293 86.8299 221.998 94.1832 213.789 100.679 207.469 108.871 203.575 118.054 199.171 128.448 199.171 140.539 199.171 164.722L199.171 279.128C199.171 414.066 383.101 511.843 447.061 541.765Z"
                stroke="currentColor"
                strokeWidth="15.5859"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeOpacity="1"
                fill="none"
                fillRule="evenodd"
                transform="matrix(1 0 0 1.10567 167.672 49.9967)"
              />
              <path
                d="M300.509 155.82 378.42 233.73"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="round"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M155.82 300.509 233.73 378.42"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="round"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M233.73 155.82 155.82 233.73"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="round"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M378.42 300.509 300.509 378.42"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="round"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M311.64 122.43C311.64 147.018 291.708 166.95 267.12 166.95 242.533 166.95 222.6 147.018 222.6 122.43 222.6 97.8426 242.533 77.91 267.12 77.91 291.708 77.91 311.64 97.8426 311.64 122.43Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M311.64 411.809C311.64 436.399 291.708 456.329 267.12 456.329 242.533 456.329 222.6 436.399 222.6 411.809 222.6 387.222 242.533 367.289 267.12 367.289 291.708 367.289 311.64 387.222 311.64 411.809Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M166.95 267.12C166.95 291.708 147.018 311.64 122.43 311.64 97.8426 311.64 77.91 291.708 77.91 267.12 77.91 242.533 97.8426 222.6 122.43 222.6 147.018 222.6 166.95 242.533 166.95 267.12Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M456.329 267.12C456.329 291.708 436.399 311.64 411.809 311.64 387.222 311.64 367.289 291.708 367.289 267.12 367.289 242.533 387.222 222.6 411.809 222.6 436.399 222.6 456.329 242.533 456.329 267.12Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M133.56 267.12C133.56 273.268 128.577 278.249 122.43 278.249 116.283 278.249 111.3 273.268 111.3 267.12 111.3 260.972 116.283 255.989 122.43 255.989 128.577 255.989 133.56 260.972 133.56 267.12Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M278.249 411.809C278.249 417.957 273.268 422.94 267.12 422.94 260.972 422.94 255.989 417.957 255.989 411.809 255.989 405.664 260.972 400.68 267.12 400.68 273.268 400.68 278.249 405.664 278.249 411.809Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
              <path
                d="M422.94 267.12C422.94 273.268 417.957 278.249 411.809 278.249 405.664 278.249 400.68 273.268 400.68 267.12 400.68 260.972 405.664 255.989 411.809 255.989 417.957 255.989 422.94 260.972 422.94 267.12Z"
                stroke="currentColor"
                strokeWidth="22.26"
                strokeLinecap="butt"
                strokeLinejoin="miter"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00677 0 0 1 367.978 91.3815)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
